import React, {useContext, useEffect, useState} from "react";
import {useViewerStore} from "../../../../../store/store";
import {Button, Flex} from "antd";
import completedIcon from "../../../../../assets/img/icons/completed-icon.png";
import errorIcon from "../../../../../assets/img/icons/error-icon.png";
import {useExportCalculationPrep} from "../../../../../hooks/calculationStateHook";
import Toggle from "../../../../Pure-UI-Components/Toggle/Toggle";
import {generateSiteReport} from "../../Drawer/Drawer-Sections/5-Reports-Section/Reports/Site_Report";
import {UnitContext} from "../../../../../contexts/UnitContext";

const SiteReportPopup = () => {

    const {sceneViewer, isHideAllGhostTrees} = useViewerStore(state => state);
    const unitContext = useContext(UnitContext);
    const [pdfGenerationStatus, setPdfGenerationStatus] = useState("default");
    const { prepReady, blockedMessage, isBlocked } = useExportCalculationPrep();
    const {isRoofSquareInitialDataLoaded , isRoofSquarePriceUpdated} = useViewerStore();
    const selectedLossesVendor = useViewerStore(state => state.selectedLossesVendor);

    const confirmGenerateReport = async () => {
        setPdfGenerationStatus('generating');
        const pdf = await generateSiteReport(sceneViewer, useViewerStore.getState(), unitContext);
        if (pdf) {
            const sfidString = sessionStorage.getItem('SalesForceId');
            pdf.save(`oneDRAW_Site_Report_${sfidString}.pdf`); // Download the pdf
            setPdfGenerationStatus('success');
        } else {
            setPdfGenerationStatus('error');
        }
    }

    const onChangeHideAllGhostTrees = () => {
        sceneViewer.hideObject("GhostTree", !isHideAllGhostTrees);
        useViewerStore.setState({isHideAllGhostTrees: !isHideAllGhostTrees});
    }

    const cancel = () => sceneViewer.viewerAlert({show: false});
    const isProd = () => import.meta.env.VITE_FRONTEND_BASE_URL === 'https://onedraw.trinity-solar.com';
    const roofSquarePending = isProd() && (!isRoofSquareInitialDataLoaded || !isRoofSquarePriceUpdated);
    const confirmDisabled = !prepReady || roofSquarePending;

    return (
        <>
            {

                pdfGenerationStatus === 'success'
                    ? (<Flex vertical justify={'center'} align={'center'}>
                        <p className="report-text">Site Report PDF Generated Successfully</p>
                        <img
                            src={completedIcon}
                            alt={"Completed Icon"}
                            width={50}
                            height={50}
                        /></Flex>)
                    : pdfGenerationStatus === 'error'
                        ? (<Flex vertical justify={'center'} align={'center'} gap={5}>
                            <p>oneDRAW Site Report PDF Generation Failed</p>
                            <img
                                src={errorIcon}
                                alt={"Error Icon"}
                                width={50}
                                height={50}
                            /></Flex>)
                        : pdfGenerationStatus === 'generating'
                            ? (<Flex justify={'center'} align={'center'} gap={10}>
                                <span className="loader-icon-spinner"></span>
                                <p>Generating oneDRAW Site Report Layout PDF</p>
                            </Flex>)
                            : isBlocked
                                ? (<Flex justify={'center'} align={'center'} gap={10}>
                                    <span className="loader-icon-spinner"></span>
                                    <p>{blockedMessage ?? 'Re-Calculating shades for all roofs…'}</p>
                                </Flex>)
                                : (<>
                                    {roofSquarePending
                                        ? <p className="report-text">Please wait, roof square data is being fetched...</p>
                                        : <>
                                            <p className="report-text">Click Confirm to Generate and Download oneDRAW Site Report Layout PDF</p>
                                            <span className="tab__column--subtitle mb-0">Hide All Ghost Trees for Site Report</span>
                                            <Toggle on={isHideAllGhostTrees} onChange={onChangeHideAllGhostTrees}/>
                                        </>
                                    }
                                    {selectedLossesVendor !== 'oneDRAW' &&
                                        <p className="report-text">Selected Vendor: {selectedLossesVendor}</p>
                                    }

                                    <div className={"modal-bottom-action-button-container"}>
                                        <Button
                                            id={"confirmSiteReportBtn"}
                                            type="primary"
                                            size="large"
                                            className="editor__control--finalize modal-confirm-button"
                                            disabled={confirmDisabled}
                                            onClick={confirmGenerateReport}
                                        >
                                            Confirm
                                        </Button>
                                        <Button
                                            type="primary"
                                            size="large"
                                            className="editor__control--finalize modal-cancel-button"
                                            onClick={cancel}
                                        >
                                            Cancel
                                        </Button>
                                    </div>

                                </>)


            }
        </>
    )


}

export default SiteReportPopup;